import React from "react";
import PropTypes from "prop-types";

import Layout from "./components/layout";
import SEO from "./components/seo";
import PropertyList from "./components/property-list";
import PropertySearch from "./components/property-search";
import Properties from "../../common/Properties";
import Paginator from "../../common/Paginator";
import { templateVariableValue } from "../../helpers/templateVariables";
import { translateStatic } from "../../helpers/translationHelper";
import * as theme3Styles from "../theme3/scss/theme3.module.scss";

// import downArrow from "./images/down-arrow-color.png";

class Theme3Properties extends Properties {
  constructor(props) {
    super(props);
  }

  renderProperties() {
    const { 
      result, 
      location 
    } = this.props;

    const {
      currentLocaleKey: locale, 
      defaultLocaleKey: defaultLocale
    } = result;

    return (
      <div className={`${theme3Styles.mainContent}`}>
        <div className={theme3Styles.wrapper}>
          <div className={`${theme3Styles.propHeader}`}>
            <div className={`${theme3Styles.propHeaderLeft}`}>
              <h2 className={`${theme3Styles.pageTitle} ${theme3Styles.mb10}`}>
                {translateStatic("properties", locale, defaultLocale)}
              </h2>
              <div className={`${theme3Styles.pageTitleBottom}`}>
                <span className={`${theme3Styles.resultCount}`}>
                  {this.state.searchedProperties.length}{" "}
                  {translateStatic("results", locale, defaultLocale)}
                </span>
              </div>
            </div>
            <div className={`${theme3Styles.propHeaderRight}`}>
              <select
                className={`${theme3Styles.field}`}
                value={this.state.sort}
                onChange={this.handleSortChange}
              >
                <option value="">Sort</option>
                {Object.keys(this.state.sortOptions).map((key) => {
                  return (
                    <option value={key} key={key}>
                      {this.state.sortOptions[key]}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <PropertyList
            properties={this.state.properties}
            locale={locale}
            defaultLocale={defaultLocale}
          />
          <Paginator
            themeStyles={theme3Styles}
            paginator={this.state.paginatorInfo}
            prefix={this.state.navigationPrefix}
            search={location.search}
          />
        </div>
        {(() => {
          if (this.state.paginatorInfo.total == 0) {
            return (
              <div className={`${theme3Styles.noDataMsg}`}>
                <span>
                  {translateStatic("no_property_found", locale, defaultLocale)}
                </span>
              </div>
            );
          }
        })()}
      </div>
    );
  }

  render() {
    const { 
      result, 
      pageContext, 
      location
    } = this.props;

    const {
      allProperties, 
      propertyCategories, 
      propertyTypes
    } = pageContext;

    const {
      remarso: {
        domainByURL: {
          website: {
            templateConfiguration,
            template: { templateVariables },
          },
        },
      },
      currentLocaleKey: locale, 
      defaultLocaleKey: defaultLocale
    } = result;

    const metaTitle = templateVariableValue(
      templateConfiguration,
      templateVariables,
      "meta-title-properties",
      locale,
      defaultLocale
    );

    return (
      <Layout>
        <SEO metaTitle={metaTitle} />

        <div className={`${theme3Styles.listingHeaderC}`}>
          <div className={theme3Styles.wrapper}>
            <div className={`${theme3Styles.listingHeader}`}>
              <PropertySearch
                properties={allProperties}
                setProperties={this.setProperties}
                propertyCategories={propertyCategories}
                propertyTypes={propertyTypes}
                locale={locale}
                defaultLocale={defaultLocale}
                navigationPrefix={this.state.navigationPrefix}
                location={location}
              />
            </div>
          </div>
        </div>

        {this.renderProperties()}
      </Layout>
    );
  }
}

export default Theme3Properties;

Theme3Properties.propTypes = {
  pageContext: PropTypes.object.isRequired,
  result: PropTypes.object,
  location: PropTypes.object,
};
